import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=0587dfec&scoped=true&"
import script from "./Declarations.vue?vue&type=script&lang=js&"
export * from "./Declarations.vue?vue&type=script&lang=js&"
import style0 from "./Declarations.vue?vue&type=style&index=0&id=0587dfec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587dfec",
  null
  
)

export default component.exports